import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}tickets`;

export interface RefreshTicketCommandArgs {
  ticketId: string;
}

export interface TicketRefreshInformationDto {
  ticketId: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const refreshTicketRequest = (
  payload: RefreshTicketCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.ticketId}/refresh`,
  config: { method: SUPPORTED_METHODS.PUT },
});

export const refreshTicketCommand = async (
  payload: RefreshTicketCommandArgs,
): Promise<BackResponse<TicketRefreshInformationDto> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<TicketRefreshInformationDto>>(
      refreshTicketRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
